let analytics;

if (process.env.WEB !== 'true') {
  analytics = require('@react-native-firebase/analytics').default();
} else if (process.env.BROWSER) {
  const firebaseConfig = {
    apiKey: 'AIzaSyB9dsHceZMabRuEJSfFww63LHTHRa6ZT3k',
    authDomain: 'relevant-analytics-ca794.firebaseapp.com',
    databaseURL: 'https://relevant-analytics-ca794.firebaseio.com',
    projectId: 'relevant-analytics-ca794',
    storageBucket: 'relevant-analytics-ca794.appspot.com',
    messagingSenderId: '271994332492',
    appId: '1:271994332492:web:01bc8c4df595c53aabdbe9',
    measurementId: 'G-2LEKXXY11Y',
  };
  // Initialize Firebase
  window?.firebase?.initializeApp(firebaseConfig);
  analytics = window?.firebase?.analytics();
}

export const Analytics = analytics;
